import BaseEntity from "./base.entity";
import Moment from "moment";
import Big from "big.js";

class Discount extends BaseEntity {
  defaultParams() {
    return {
      description: "",
      type: "",
      percentual_value: 0,
      discount_value: 0,
      minimum_value: 0,
      start_date: "",
      end_date: "",
      rule_text: "",
      cpf_required: false,
      enabled: true
    };
  }

  getServiceObject() {
    return {
      description: this.description,
      type: this.type,
      percentual_value: parseInt(this.percentual_value, 10) || 0,
      discount_value: parseInt(this.discount_value, 10) || 0,
      minimum_value: parseInt(this.minimum_value, 10) || 0,
      start_date: this.startDate,
      end_date: this.endDate,
      rule_text: this.rule_text,
      cpf_required: this.cpf_required,
      enabled: this.enabled
    };
  }

  identifier() {
    return this.description || "Desconto não identificado";
  }

  getDiscountValue() {
    return this.discount_value ? Big(this.discount_value) : Big(0);
  }

  getMinimumValue() {
    return this.minimum_value ? Big(this.minimum_value) : Big(0);
  }

  getPercentualValue() {
    return this.percentual_value ? Big(this.percentual_value) : Big(0);
  }

  getStartDate() {
    return Moment(this.start_date).format("DD/MM/YYYY");
  }

  getEndDate() {
    return Moment(this.end_date).isValid()
      ? Moment(this.end_date).format("DD/MM/YYYY")
      : "";
  }
}

export default Discount;



// WEBPACK FOOTER //
// ./src/core/entity/discount.entity.js